import Heading3 from './Heading3'
export default Heading3
